import { Stack } from "@mui/material";
import { AssetInfoRow } from "components/BuildingProfile/AssetInfo";
import { DropzoneSingle } from "components/Dropzone";
import { ApiFileRow, LocalFileRow } from "components/FileRow";
import { SingleBuildingContext } from "features/dt-basic-setup/single-building/context/AddSingleBuildingContext";
import {
  FileWithInfo,
  isFileFromApi,
  SummaryStepSummaryContentProps,
} from "features/dt-basic-setup/single-building/model/types";
import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { valueOrAlternative } from "utils/namesManipulation";

export const SummaryStepImageUploadAndContentSummary = ({
  handleImageChange,
  handleRemoveImage,
  images,
}: SummaryStepSummaryContentProps) => {
  const { t } = useTranslation();
  const { formData } = useContext(SingleBuildingContext);
  const addressInfo = formData?.addressInfo;

  const summaryRows = useMemo(
    () => [
      { label: t("AddBuilding.summaryStep.summaryRows.assetName"), value: valueOrAlternative(addressInfo?.name) },
      { label: t("AddBuilding.summaryStep.summaryRows.assetId"), value: valueOrAlternative(formData?.asset_id) },
      {
        label: t("AddBuilding.summaryStep.summaryRows.address"),
        value: valueOrAlternative(
          [
            addressInfo?.address,
            [addressInfo?.postal_code, addressInfo?.city].filter(Boolean).join(" "),
            addressInfo?.country,
          ]
            .filter(Boolean)
            .join(", ")
        ),
      },
    ],
    [addressInfo, formData?.asset_id, t]
  );

  const removeFileProps = (image: FileWithInfo) => ({ key: image.id, removeFile: () => handleRemoveImage(image) });

  return (
    <>
      <DropzoneSingle acceptedFormats={["image/*"]} className="mb-4 h-65 w-full" handleFileChange={handleImageChange} />
      {images?.length > 0 && (
        <Stack className="w-full flex-col gap-1 ">
          {images?.map((image) => (
            <>
              {isFileFromApi(image) ? (
                <ApiFileRow file={{ name: "", src: image.url }} {...removeFileProps(image)} />
              ) : (
                <LocalFileRow file={image.file} {...removeFileProps(image)} />
              )}
            </>
          ))}
        </Stack>
      )}
      <Stack className="mt-7 w-full flex-col items-start gap-2" component="ul">
        {summaryRows.map((item) => (
          <AssetInfoRow className="w-full" key={item.label} label={item.label} value={item.value} />
        ))}
      </Stack>
    </>
  );
};
